import LegalPage from "@/components/LegalPage";

const SECTIONS = [
    {
        h: "General Information Only",
        p: [
            "The content on this website is published by Vivek Coaching Centre for general information about our courses, batches and contact details. It is shared in good faith and does not constitute an admission offer, a contractual commitment, or professional academic counselling.",
        ],
    },
    {
        h: "No Guarantee of Results",
        p: [
            "While our faculty follow structured, disciplined teaching methods, academic outcomes depend on many factors including a student's own effort, consistency and prior preparation. Enrollment at our centre is not a guarantee of any specific rank, score or selection in any examination.",
        ],
    },
    {
        h: "Accuracy of Content",
        p: [
            "We take care to keep course information, batch details and contact information accurate and current. However, schedules, batch availability and offerings may change; we encourage you to confirm current details directly with us before making decisions.",
        ],
    },
    {
        h: "External Links",
        p: [
            "Any external links on this website (such as WhatsApp or email) are provided for your convenience. We are not responsible for the content or privacy practices of third-party platforms once you leave this website.",
        ],
    },
    {
        h: "Limitation of Liability",
        p: [
            "To the fullest extent permitted by law, Vivek Coaching Centre shall not be liable for any loss or inconvenience arising from reliance placed on website content, or from decisions made without confirming details with our staff directly.",
        ],
    },
    {
        h: "Consent",
        p: [
            "By using this website and submitting an enquiry, you consent to this disclaimer and to our Privacy Policy.",
        ],
    },
    {
        h: "Contact for Clarifications",
        p: [
            "If anything on this website is unclear, please reach us at zyne6431@gmail.com or call +91 6207984279 before acting on it.",
        ],
    },
];

const Disclaimer = () => (
    <LegalPage
        eyebrow="Disclaimer"
        testid="disclaimer-page"
        titleLines={[
            "Fair, clear",
            <span key="a" className="f-serif normal-case font-medium text-[#FF5500]">
                &amp; upfront.
            </span>,
        ]}
        intro="This disclaimer governs your use of the Vivek Coaching Centre website. By using this website, you accept this disclaimer in full."
        sections={SECTIONS}
    />
);

export default Disclaimer;
